(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avenor-home-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.av-mobile-menu nav a');
  if (link) link.closest('details').removeAttribute('open');
});

function initAvenorAnnouncements(scope=document){
 scope.querySelectorAll('[data-av-announcement]').forEach(root=>{
  if(root.dataset.avaReady)return;root.dataset.avaReady='true';
  const slides=Array.from(root.querySelectorAll('[data-ava-message]'));
  if(slides.length<2)return;
  let index=0,timer,transition;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const start=()=>{clearInterval(timer);if(!document.hidden&&!root.contains(document.activeElement))timer=setInterval(next,5000);};
  const next=()=>{
   if(!root.isConnected){clearInterval(timer);clearTimeout(transition);return;}
   if(document.hidden||root.contains(document.activeElement))return;
   const current=slides[index];current.classList.remove('ava-enter');current.classList.add('ava-leaving');
   transition=setTimeout(()=>{
    current.hidden=true;current.classList.remove('ava-leaving');
    index=(index+1)%slides.length;
    slides[index].hidden=false;slides[index].classList.add('ava-enter');
   },reduce.matches?0:180);
  };
  root.addEventListener('focusin',()=>{clearInterval(timer);clearTimeout(transition);slides[index].classList.remove('ava-leaving');});
  root.addEventListener('focusout',()=>setTimeout(start,0));
  document.addEventListener('visibilitychange',()=>{clearTimeout(transition);slides[index].classList.remove('ava-leaving');start();});
  start();
 });
}
initAvenorAnnouncements();
document.addEventListener('shopify:section:load',event=>initAvenorAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avenor-home"] && !Shopify.designMode) return;
  try {
    
const avenorReveal = () => { if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; const observer = new IntersectionObserver((entries) => { entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('av-visible'); observer.unobserve(entry.target); } }); }, {threshold:0.08}); document.querySelectorAll('.av-card,.av-section-head,.av-feature,.av-scene-content').forEach(el => {el.classList.add('av-reveal'); observer.observe(el);}); }; avenorReveal(); document.addEventListener('shopify:section:load',avenorReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avenor-store-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ax-catalog]').forEach(root => {
  const buttons = root.querySelectorAll('[data-ax-filter]');
  buttons.forEach(button => { const category = button.dataset.axFilter; button.querySelector('.ax-filter-count').textContent = Array.from(root.querySelectorAll('[data-ax-category]')).filter(card => category === 'all' || card.dataset.axCategory === category).length; });
  buttons.forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.axFilter;
    let count = 0;
    root.querySelectorAll('[data-ax-category]').forEach(card => {
      const show = category === 'all' || card.dataset.axCategory === category;
      card.hidden = !show;
      if (show) count++;
    });
    buttons.forEach(item => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
    root.querySelector('[data-ax-count]').textContent = count;
    root.querySelector('[data-ax-empty]').hidden = count !== 0;
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
